import React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import { Typography } from "@mui/material";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import RoomServiceIcon from "@mui/icons-material/RoomService";
import Avatar from "@mui/material/Avatar";

function ServiceList({ services }) {
  return (
    <>
      <ListItem sx={{ pb: 2 }}>
        <ListItemAvatar>
          <Avatar>
            <RoomServiceIcon />
          </Avatar>
        </ListItemAvatar>
        <Typography component="div" sx={{ fontSize: "2rem", fontWeight: 500 }}>
          Služby
        </Typography>
      </ListItem>
      <List component="div" disablePadding>
        {services.map((service) => (
          <ListItem sx={{ pl: 4, pb: 0, pt: 0 }}>
            <ListItemAvatar sx={{ minWidth: "30px" }}>
              <ArrowRightIcon />
            </ListItemAvatar>
            <Typography
              key={service}
              component={"div"}
              sx={{ fontSize: "1.8rem" }}
            >
              {service}
            </Typography>
          </ListItem>
        ))}
      </List>
    </>
  );
}

export default ServiceList;
